var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"backup-img",attrs:{"data-testid":"back-img-index-2Wadxf","src":_vm.xss.filterUrl(_vm.value, null, { logType: "js.href/src", reportOnly: false})},on:{"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }